module.exports = __webpack_public_path__ + "static/media/SRPF47_01.7b81dbc0.png";